/* ==========================================================
   MARCZEN — OFERTAS POR CANTIDAD
   JAVASCRIPT GENERAL V1
   ==========================================================

   FUNCIONAMIENTO:

   1. Detecta la oferta seleccionada en el landing.
   2. Actualiza la cantidad nativa de Shopify.
   3. Al pulsar el botón de Releasit, transfiere la oferta.
   4. La transferencia se realiza una sola vez.
   5. Los cambios posteriores dentro de Releasit
      tienen prioridad.

   SIN:
   - localStorage
   - sessionStorage
   - MutationObserver
   - Sincronización permanente

   ========================================================== */

(function () {

  'use strict';

  /* EVITAR INICIALIZACIONES DUPLICADAS */

  if (window.marczenQuantityOffersInitialized) {
    return;
  }

  window.marczenQuantityOffersInitialized = true;


  /* CONFIGURACIÓN GENERAL */

  const ROOT_SELECTOR = '[data-marczen-offers]';

  const LANDING_INPUT =
    '.marczen-oferta-input';

  const RELEASIT_INPUT =
    'input[name="quantity_offer"]';


  /* IDENTIFICAR EL SISTEMA */

  const landing = document.querySelector(
    ROOT_SELECTOR
  );

  if (!landing) {
    return;
  }


  /* ESTADO DE TRANSFERENCIA */

  let transferAlreadyExecuted = false;

  let transferInProgress = false;


  /* OBTENER OFERTA SELECCIONADA */

  function getSelectedOffer() {

    const selected = landing.querySelector(
      LANDING_INPUT + ':checked'
    );

    if (!selected) {
      return null;
    }

    const card = selected.closest(
      '[data-marczen-offer]'
    );

    if (!card) {
      return null;
    }

    const quantity = Number(
      card.dataset.marczenQuantity
    );

    if (
      !Number.isInteger(quantity) ||
      quantity < 1
    ) {
      return null;
    }

    return {
      offerId: String(selected.value),
      quantity: quantity
    };

  }


  /* OBTENER CANTIDAD NATIVA DE SHOPIFY */

  function getNativeQuantityInput() {

    const selectors = [
      'form[action*="/cart/add"] input[name="quantity"]',
      'form[action*="/cart/add"] select[name="quantity"]',
      'input[name="quantity"]',
      'select[name="quantity"]'
    ];

    for (const selector of selectors) {

      const elements = document.querySelectorAll(
        selector
      );

      for (const element of elements) {

        if (element.closest(ROOT_SELECTOR)) {
          continue;
        }

        if (element.closest('.rsi-modal')) {
          continue;
        }

        return element;

      }

    }

    return null;

  }


  /* ACTUALIZAR CANTIDAD NATIVA */

  function setNativeQuantity(quantity) {

    if (
      !Number.isInteger(quantity) ||
      quantity < 1
    ) {
      return;
    }

    const input = getNativeQuantityInput();

    if (!input) {
      return;
    }

    const value = String(quantity);

    if (input instanceof HTMLInputElement) {

      const descriptor =
        Object.getOwnPropertyDescriptor(
          HTMLInputElement.prototype,
          'value'
        );

      if (descriptor && descriptor.set) {

        descriptor.set.call(
          input,
          value
        );

      } else {

        input.value = value;

      }

    } else {

      input.value = value;

    }

    input.dispatchEvent(
      new Event('input', {
        bubbles: true
      })
    );

    input.dispatchEvent(
      new Event('change', {
        bubbles: true
      })
    );

  }


  /* SELECCIÓN DE OFERTAS EN EL LANDING */

  landing.addEventListener(
    'change',
    function (event) {

      if (!event.target.matches(LANDING_INPUT)) {
        return;
      }

      const offer = getSelectedOffer();

      if (!offer) {
        return;
      }

      setNativeQuantity(offer.quantity);

    }
  );


  /* BUSCAR OFERTA EN RELEASIT */

  function findReleasitOffer(offerId) {

    const inputs = document.querySelectorAll(
      RELEASIT_INPUT
    );

    for (const input of inputs) {

      if (String(input.value) !== offerId) {
        continue;
      }

      const rect = input.getBoundingClientRect();

      const style = window.getComputedStyle(input);

      if (
        rect.width > 0 &&
        rect.height > 0 &&
        style.display !== 'none' &&
        style.visibility !== 'hidden'
      ) {
        return input;
      }

    }

    for (const input of inputs) {

      if (String(input.value) === offerId) {
        return input;
      }

    }

    return null;

  }


  /* TRANSFERIR OFERTA UNA SOLA VEZ */

  function transferOfferToReleasit(offerId) {

    if (
      transferAlreadyExecuted ||
      transferInProgress
    ) {
      return;
    }

    transferInProgress = true;

    let attempts = 0;

    const maxAttempts = 100;

    const interval = setInterval(
      function () {

        attempts++;

        const target = findReleasitOffer(
          offerId
        );

        if (!target) {

          if (attempts >= maxAttempts) {

            clearInterval(interval);

            transferInProgress = false;

          }

          return;

        }

        clearInterval(interval);

        transferInProgress = false;

        transferAlreadyExecuted = true;

        if (target.checked) {
          return;
        }

        target.click();

      },
      100
    );

  }


  /* IDENTIFICAR BOTÓN DE PEDIDO */

  function isOrderButton(element) {

    if (!element) {
      return false;
    }

    const text = (
      element.innerText ||
      element.textContent ||
      element.getAttribute('aria-label') ||
      ''
    )
      .trim()
      .toLowerCase()
      .replace(/\s+/g, ' ');

    const phrases = [
      'pide y paga al recibir en casa',
      'iniciar el pago',
      'inicia el pago',
      'realiza tu pedido',
      'realizar pedido',
      'realiza pedido'
    ];

    return phrases.some(
      function (phrase) {
        return text.includes(phrase);
      }
    );

  }


  /* DETECTAR CLIC EN EL BOTÓN DE RELEASIT */

  document.addEventListener(
    'click',
    function (event) {

      const button = event.target.closest(
        'button, a, [role="button"]'
      );

      if (!button) {
        return;
      }

      if (!isOrderButton(button)) {
        return;
      }

      const offer = getSelectedOffer();

      if (!offer) {
        return;
      }

      setNativeQuantity(offer.quantity);

      transferOfferToReleasit(offer.offerId);

    },
    true
  );

})();